import { combineReducers } from 'redux';
import { reducer as precisionPolicy } from './precisionPolicy';
import { reducer as mbrPolicy } from './mbrPolicy';
import { reducer as schedule } from './schedule';

export default combineReducers({
  precisionPolicy,
  mbrPolicy,
  schedule,
});
